webpackJsonp([11],{

/***/ 1120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_cycledetail_js__ = __webpack_require__(1367);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76f9d240_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cycledetail_vue__ = __webpack_require__(1613);
function injectStyle (ssrContext) {
  __webpack_require__(1607)
}
var normalizeComponent = __webpack_require__(509)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76f9d240"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_cycledetail_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76f9d240_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cycledetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(511);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  listSupplier: function listSupplier(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'cycle', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getOrderProcess: function getOrderProcess(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'cycle/orderprocess', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getDock: function getDock(URL, id, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'cycle/dock?spl_id=' + id, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getSupplier: function getSupplier(URL, id, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'cycle/supplier?spl_id=' + id, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  listPattern: function listPattern(URL, id, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'cycle/pattern?spl_id=' + id, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getCycleDetail: function getCycleDetail(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'cycle/detail', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getCycleDetailid: function getCycleDetailid(URL, id, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'cycle/detailid?cdc_id=' + id, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  addCycle: function addCycle(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'cycle', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  editCycle: function editCycle(URL, id, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.put(URL + 'cycle/' + id, obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  orderStatus: function orderStatus(URL, id, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.put(URL + 'cycle/orderstatus/' + id, obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  orderActive: function orderActive(URL, id, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.put(URL + 'cycle/orderactive/' + id, obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  deleteCycle: function deleteCycle(URL, id, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.delete(URL + 'cycle/' + id, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  addCycleList: function addCycleList(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'cyclelist', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  editCycleList: function editCycleList(URL, id, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.put(URL + 'cyclelist/' + id, obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  deleteCycleList: function deleteCycleList(URL, id, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.delete(URL + 'cyclelist/' + id, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_cycle__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modal_cycle_edit_modal__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal_cycle_add_modal__ = __webpack_require__(1611);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cycledetail',
  components: {
    CycleEditModal: __WEBPACK_IMPORTED_MODULE_2__components_modal_cycle_edit_modal__["a" /* default */],
    CycleAddModal: __WEBPACK_IMPORTED_MODULE_3__components_modal_cycle_add_modal__["a" /* default */]
  },
  data: function data() {
    return {
      is_active: 99,
      per_page: 100,
      active_page: 1,
      isLoad: false,
      date_select: null,
      str_data: '',
      modal_type: null,
      spl_id: '',
      spl_code: '',
      spl_name: '',
      spl_plant_code: '',
      result_data: {
        pagination: [],
        count: 0
      },
      modal_data: {
        opc_id: '',
        cdmp_id: '',
        spl_id: '',
        dk_id: '',
        cdc_date: '',
        cdc_truck_no: '',
        cdc_cycle_x: '',
        cdc_cycle_y: '',
        cdc_cycle_z: '',
        cdc_delivery_x: '',
        cdc_delivery_y: '',
        cdc_delivery_z: ''
      }
    };
  },

  methods: {
    backTopage: function backTopage() {
      this.$router.push({
        name: 'cycle'
      });
    },
    itemRender: function itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous';
      } else if (type === 'next') {
        return 'Next';
      }
      return originalElement;
    },
    activePage: function activePage(value) {
      this.active_page = value;
      this.search();
    },
    search: function search() {
      var _this = this;

      this.isLoad = true;
      var obj = {
        spl_id: this.spl_id,
        active: this.is_active,
        date: this.date_select === null ? '' : this.dateMonth(this.date_select),
        page: this.active_page,
        limit: this.per_page
      };
      this.result_data.pagination = [];
      this.result_data.count = 0;
      this.header.params = obj;
      __WEBPACK_IMPORTED_MODULE_1__models_cycle__["a" /* default */].getCycleDetail(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this.result_data = result.data;
        } else {
          _this.alert_msg('warning', 'Cycle', result.message);
        }
        _this.isLoad = false;
      }, function (error) {
        _this.alert_msg('error', 'Cycle', error.message);
        _this.isLoad = false;
      });
    },
    getSupplier: function getSupplier() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__models_cycle__["a" /* default */].getSupplier(this.$store.state.URLHost, this.spl_id, this.header, function (result) {
        if (result.response === true) {
          _this2.spl_code = result.data.code;
          _this2.spl_name = result.data.name;
          _this2.spl_plant_code = result.data.plantcode;
        } else {
          _this2.alert_msg('warning', 'Cycle', result.message);
        }
      }, function (error) {
        _this2.alert_msg('error', 'Cycle', error.message);
      });
    },
    addCycle: function addCycle() {
      this.modal_type = 0;
      this.modal_data = {
        opc_id: 1,
        cdmp_id: '',
        dk_id: '',
        spl_id: this.spl_id,
        spl_name: this.spl_name,
        spl_plant_code: this.spl_plant_code,
        cdc_date: null,
        cdc_truck_no: '',
        cdc_cycle_x: '',
        cdc_cycle_y: '',
        cdc_cycle_z: '',
        cdc_delivery_x: '',
        cdc_delivery_y: '',
        cdc_delivery_z: ''
      };
      this.ModalBoots('CycleModal').show();
    },
    editCycle: function editCycle(obj) {
      this.modal_type = 1;
      this.modal_data = obj;
      this.ModalBoots('CycleModal').show();
    },
    orderStatus: function orderStatus(obj) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
        title: 'Are you sure?',
        text: 'Confirm Order Status : ' + (obj.cdc_is_disable === 0 ? 'Disable' : 'Enable'),
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#67757c',
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel'
      }).then(function (result) {
        if (result.value) {
          var formData = {
            cdc_is_disable: obj.cdc_is_disable === 0 ? 1 : 0
          };
          __WEBPACK_IMPORTED_MODULE_1__models_cycle__["a" /* default */].orderStatus(_this3.$store.state.URLHost, obj.cdc_id, formData, _this3.header, function (result) {
            if (result.response === true) {
              _this3.alert_msg('success', 'Successful.', result.message);
            } else {
              _this3.alert_msg('error', 'An error occurred.', result.message);
            }
            _this3.search();
          }, function (error) {
            _this3.alert_msg('error', 'An error occurred.', error.message);
            _this3.search();
          });
        }
      });
    },
    activeCycle: function activeCycle(obj) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
        title: 'Are you sure?',
        text: 'Confirm Active : Cycle Date ' + this.dateFormatDMY(obj.cdc_date),
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#67757c',
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel'
      }).then(function (result) {
        if (result.value) {
          var formData = {
            spl_id: obj.spl_id,
            dk_id: obj.dk_id
          };
          __WEBPACK_IMPORTED_MODULE_1__models_cycle__["a" /* default */].activeCycle(_this4.$store.state.URLHost, obj.cdc_id, formData, _this4.header, function (result) {
            if (result.response === true) {
              _this4.alert_msg('success', 'Successful.', result.message);
            } else {
              _this4.alert_msg('error', 'An error occurred.', result.message);
            }
            _this4.search();
          }, function (error) {
            _this4.alert_msg('error', 'An error occurred.', error.message);
            _this4.search();
          });
        }
      });
    },
    deleteCycle: function deleteCycle(obj) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
        title: 'Are you sure?',
        text: 'Confirm delete : Pattern ' + obj.cdp_name + ' Cycle date ' + this.dateFormatDMY(obj.cdc_date),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#67757c',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel'
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_1__models_cycle__["a" /* default */].deleteCycle(_this5.$store.state.URLHost, obj.cdc_id, _this5.header, function (result) {
            if (result.response === true) {
              _this5.alert_msg('success', 'Successful.', result.message);
            } else {
              _this5.alert_msg('error', 'An error occurred.', result.message);
            }
            _this5.search();
          }, function (error) {
            _this5.alert_msg('error', 'An error occurred.', error.message);
            _this5.search();
          });
        }
      });
    }
  },
  created: function created() {
    this.checkOAuth();
  },
  mounted: function mounted() {
    var _this6 = this;

    setTimeout(function () {
      _this6.spl_id = _this6.$route.query.id !== undefined ? _this6.$route.query.id : _this6.spl_id;
      if (sessionStorage.token) {
        _this6.getSupplier();
        _this6.activePage(1);
      } else {
        setTimeout(function () {
          _this6.getSupplier();
          _this6.activePage(1);
        }, 1000);
      }
      var myModalEl = document.getElementById('CycleModal');
      myModalEl.addEventListener('hide.bs.modal', function (event) {
        _this6.modal_type = null;
      });
      $(document).on('show.bs.modal', '.modal', function () {
        var zIndex = 1040 + 10 * $('.modal:visible').length;
        $(this).css('z-index', zIndex);
        setTimeout(function () {
          $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
        }, 0);
      });
    }, 1000);
  }
});

/***/ }),

/***/ 1368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_cycle__ = __webpack_require__(1159);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['modalEditCycle', 'loadNewCycle'],
  data: function data() {
    return {
      cdc_id: '',
      opc_name: '',
      cdp_name: '',
      dk_code: '',
      cdc_date: '',
      cdc_truck_no: '',
      cdc_cycle_x: '',
      cdc_cycle_y: '',
      cdc_cycle_z: '',
      cdc_delivery_x: '',
      cdc_delivery_y: '',
      cdc_delivery_z: '',
      spl_id: '',
      spl_code: '',
      spl_name: '',
      spl_plant_code: '',
      cycleModalList: [],
      array_h: ['08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
      array_m: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55']
    };
  },

  methods: {
    checkForm: function checkForm() {
      if (this.cdc_truck_no !== '' && this.cdc_cycle_x !== '' && this.cdc_cycle_y !== '' && this.cdc_cycle_z !== '') {
        this.updateCycle();
      } else {
        $('#formEditCycle').addClass('was-validated');
      }
    },
    checkExpire: function checkExpire() {
      var a = new Date();
      var date = this.dateConvertYMD(this.cdc_date);
      var b = new Date(date);
      return parseInt((b - a) / 1000);
    },
    updateCycle: function updateCycle() {
      var _this = this;

      $('.preloader').fadeIn();
      var formData = {
        cdc_truck_no: this.cdc_truck_no,
        cdc_cycle_x: this.cdc_cycle_x,
        cdc_cycle_y: this.cdc_cycle_y,
        cdc_cycle_z: this.cdc_cycle_z,
        cdc_delivery_x: this.cdc_delivery_x,
        cdc_delivery_y: this.cdc_delivery_y,
        cdc_delivery_z: this.cdc_delivery_z,
        cycle_list: this.cycleModalList
      };
      __WEBPACK_IMPORTED_MODULE_0__models_cycle__["a" /* default */].editCycle(this.$store.state.URLHost, this.cdc_id, formData, this.header, function (result) {
        if (result.response === true) {
          _this.loadNewCycle();
          _this.alert_msg('success', 'Successful', result.message);
          $('.preloader').fadeOut();
          $('#CycleModal').modal('hide');
        } else {
          _this.loadNewCycle();
          _this.alert_msg('warning', 'An error occurred.', result.message);
          $('.preloader').fadeOut();
          $('#CycleModal').modal('hide');
        }
      }, function (error) {
        _this.loadNewCycle();
        _this.alert_msg('error', 'An error occurred.', error.message);
        $('.preloader').fadeOut();
        $('#CycleModal').modal('hide');
      });
    }
  },
  watch: {
    modalEditCycle: {
      immediate: true,
      deep: true,
      handler: function handler(newValue, oldValue) {
        this.cdc_id = newValue.cdc_id;
        this.spl_id = newValue.spl_id;
        this.spl_code = newValue.spl_code;
        this.spl_name = newValue.spl_name;
        this.spl_plant_code = newValue.spl_plant_code;
        this.opc_name = newValue.opc_name;
        this.cdp_name = newValue.cdp_name;
        this.dk_code = newValue.dk_code;
        this.cdc_date = this.dateFormatDMY(newValue.cdc_date);
        this.cdc_truck_no = newValue.cdc_truck_no;
        this.cdc_cycle_x = newValue.cdc_cycle_x;
        this.cdc_cycle_y = newValue.cdc_cycle_y;
        this.cdc_cycle_z = newValue.cdc_cycle_z;
        this.cdc_delivery_x = newValue.cdc_delivery_x;
        this.cdc_delivery_y = newValue.cdc_delivery_y;
        this.cdc_delivery_z = newValue.cdc_delivery_z;
        this.cycleModalList = newValue.cycle_list_data;
        $(document).on('show.bs.modal', '.modal', function () {
          var zIndex = 1040 + 10 * $('.modal:visible').length;
          $(this).css('z-index', zIndex);
          setTimeout(function () {
            $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
          }, 0);
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var myModalEl = document.getElementById('CycleModal');
    myModalEl.addEventListener('hide.bs.modal', function (event) {
      // this.cdc_id = this.modalEditCycle.cdc_id
      // this.spl_id = this.modalEditCycle.spl_id
      // this.cdc_date = this.dateFormatDMY2(this.modalEditCycle.cdc_date)
      // this.cdc_truck_no = this.modalEditCycle.cdc_truck_no
      // this.cdc_cycle_x = this.modalEditCycle.cdc_cycle_x
      // this.cdc_cycle_y = this.modalEditCycle.cdc_cycle_y
      // this.cdc_cycle_z = this.modalEditCycle.cdc_cycle_z
      // this.cdc_delivery_x = this.modalEditCycle.cdc_delivery_x
      // this.cdc_delivery_y = this.modalEditCycle.cdc_delivery_y
      // this.cdc_delivery_z = this.modalEditCycle.cdc_delivery_z
      // this.cycleModalList = this.modalEditCycle.cycle_list_data
      _this2.cdc_date = '';
      $('#formEditCycle').removeClass('was-validated');
    });
    $(document).on('show.bs.modal', '.modal', function () {
      var zIndex = 1040 + 10 * $('.modal:visible').length;
      $(this).css('z-index', zIndex);
      setTimeout(function () {
        $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
      }, 0);
    });
  }
});

/***/ }),

/***/ 1369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_cycle__ = __webpack_require__(1159);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['modalAddCycle', 'loadNewCycle'],
  data: function data() {
    return {
      opc_id: 1,
      cdmp_id: '',
      spl_id: '',
      dk_id: '',
      cdc_date: null,
      cdc_truck_no: 1,
      cdc_cycle_x: 1,
      cdc_cycle_y: 1,
      cdc_cycle_z: 1,
      cdc_delivery_x: 1,
      cdc_delivery_y: 1,
      cdc_delivery_z: 1,
      spl_code: '',
      spl_name: '',
      spl_plant_code: '',
      patternModalList: [],
      dockModalList: []
    };
  },

  methods: {
    checkForm: function checkForm() {
      if (this.opc_id !== '' && this.cdmp_id !== '' && this.spl_id !== '' && this.dk_id !== '' && this.cdc_date !== null && this.cdc_truck_no !== '' && this.cdc_cycle_x !== '' && this.cdc_cycle_y !== '' && this.cdc_cycle_z !== '' && this.cdc_delivery_x !== '' && this.cdc_delivery_y !== '' && this.cdc_delivery_z !== '') {
        this.insertCycle();
      } else {
        $('#formAddCycle').addClass('was-validated');
      }
    },
    disabledEndDate: function disabledEndDate(endValue) {
      var date = new Date();
      date.setDate(date.getDate() - 1);
      var startValue = date;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    insertCycle: function insertCycle() {
      var _this = this;

      $('.preloader').fadeIn();
      var formData = {
        opc_id: this.opc_id,
        cdmp_id: this.cdmp_id,
        spl_id: this.spl_id,
        dk_id: this.dk_id,
        cdc_date: this.cdc_date === null ? '' : this.dateFormatYMD(this.cdc_date),
        cdc_truck_no: this.cdc_truck_no,
        cdc_cycle_x: this.cdc_cycle_x,
        cdc_cycle_y: this.cdc_cycle_y,
        cdc_cycle_z: this.cdc_cycle_z,
        cdc_delivery_x: this.cdc_delivery_x,
        cdc_delivery_y: this.cdc_delivery_y,
        cdc_delivery_z: this.cdc_delivery_z
      };
      __WEBPACK_IMPORTED_MODULE_0__models_cycle__["a" /* default */].addCycle(this.$store.state.URLHost, formData, this.header, function (result) {
        if (result.response === true) {
          _this.loadNewCycle();
          _this.alert_msg('success', 'Successful', result.message);
          $('.preloader').fadeOut();
          $('#CycleModal').modal('hide');
        } else {
          _this.loadNewCycle();
          _this.alert_msg('warning', 'Warning', result.message);
          $('.preloader').fadeOut();
          $('#CycleModal').modal('hide');
        }
      }, function (error) {
        _this.loadNewCycle();
        _this.alert_msg('error', 'An error occurred.', error.message);
        $('.preloader').fadeOut();
        $('#CycleModal').modal('hide');
      });
    },

    //  getOrderProcess () {
    //    this.orderProcessModalList = []
    //    api.getOrderProcess(
    //      this.$store.state.URLHost,
    //      this.header,
    //      result => {
    //        if (result.response === true) {
    //          this.orderProcessModalList = result.data
    //        } else {
    //          this.alert_msg('warning', 'An error occurred.', result.message)
    //        }
    //      },
    //      error => {
    //        this.alert_msg('error', 'An error occurred.', error.message)
    //      }
    //    )
    //  },
    getDock: function getDock() {
      var _this2 = this;

      this.dockModalList = [];
      __WEBPACK_IMPORTED_MODULE_0__models_cycle__["a" /* default */].getDock(this.$store.state.URLHost, this.modalAddCycle.spl_id, this.header, function (result) {
        if (result.response === true) {
          _this2.dockModalList = result.data;
        } else {
          _this2.alert_msg('warning', '1 An error occurred.', result.message);
        }
      }, function (error) {
        _this2.alert_msg('error', 'An error occurred.', error.message);
      });
    },
    listPattern: function listPattern() {
      var _this3 = this;

      this.patternModalList = [];
      __WEBPACK_IMPORTED_MODULE_0__models_cycle__["a" /* default */].listPattern(this.$store.state.URLHost, this.modalAddCycle.spl_id, this.header, function (result) {
        if (result.response === true) {
          _this3.patternModalList = result.data;
        } else {
          _this3.alert_msg('warning', '2 An error occurred.', result.message);
        }
      }, function (error) {
        _this3.alert_msg('error', 'An error occurred.', error.message);
      });
    }
  },
  watch: {
    modalAddCycle: {
      immediate: true,
      deep: true,
      handler: function handler(newValue, oldValue) {
        this.spl_id = newValue.spl_id;
        this.spl_code = newValue.spl_code;
        this.spl_name = newValue.spl_name;
        this.spl_plant_code = newValue.spl_plant_code;
        $(document).on('show.bs.modal', '.modal', function () {
          var zIndex = 1040 + 10 * $('.modal:visible').length;
          $(this).css('z-index', zIndex);
          setTimeout(function () {
            $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
          }, 0);
        });
      }
    }
  },
  created: function created() {
    this.getDock();
    this.listPattern();
  },
  mounted: function mounted() {
    var _this4 = this;

    var myModalEl = document.getElementById('CycleModal');
    myModalEl.addEventListener('shown.bs.modal', function (event) {
      _this4.opc_id = 1;
      _this4.cdmp_id = '';
      _this4.spl_id = _this4.modalAddCycle.spl_id;
      _this4.dk_id = '';
      _this4.cdc_date = null;
      _this4.cdc_truck_no = 1;
      _this4.cdc_cycle_x = 1;
      _this4.cdc_cycle_y = 1;
      _this4.cdc_cycle_z = 1;
      _this4.cdc_delivery_x = 1;
      _this4.cdc_delivery_y = 1;
      _this4.cdc_delivery_z = 1;
      $('#formAddCycle').removeClass('was-validated');
    });
    $(document).on('show.bs.modal', '.modal', function () {
      var zIndex = 1040 + 10 * $('.modal:visible').length;
      $(this).css('z-index', zIndex);
      setTimeout(function () {
        $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
      }, 0);
    });
  }
});

/***/ }),

/***/ 1607:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1608);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1046)("e574d794", content, true, {});

/***/ }),

/***/ 1608:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1045)(true);
// imports


// module
exports.push([module.i, ".my-border[data-v-76f9d240]{border-right:1px solid #e9edf2}", "", {"version":3,"sources":["/vercel/path0/ui/src/views/Cycledetail.vue"],"names":[],"mappings":"AACA,4BACE,8BAAgC,CACjC","file":"Cycledetail.vue","sourcesContent":["\n.my-border[data-v-76f9d240] {\n  border-right: 1px solid #e9edf2;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1609:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cycle_edit_modal_vue__ = __webpack_require__(1368);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0155aed3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cycle_edit_modal_vue__ = __webpack_require__(1610);
var normalizeComponent = __webpack_require__(509)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cycle_edit_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0155aed3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cycle_edit_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1610:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{staticClass:"form-horizontal needs-validation",attrs:{"novalidate":"","id":"formEditCycle"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-12"},[_vm._v("Supplier Code")]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.spl_name),expression:"spl_name"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.spl_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.spl_name=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdc_id),expression:"cdc_id"}],staticClass:"form-control",attrs:{"type":"hidden"},domProps:{"value":(_vm.cdc_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdc_id=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-12"},[_vm._v("Dock")]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dk_code),expression:"dk_code"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.dk_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dk_code=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-12"},[_vm._v("Pattern")]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdp_name),expression:"cdp_name"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.cdp_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdp_name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-12"},[_vm._v("Effective date")]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdc_date),expression:"cdc_date"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.cdc_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdc_date=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-12"},[_vm._v("Plant Code")]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.spl_plant_code),expression:"spl_plant_code"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.spl_plant_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.spl_plant_code=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-12"},[_vm._v("Order Process Category")]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.opc_name),expression:"opc_name"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.opc_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.opc_name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-12"},[_vm._v("Truck No.")]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdc_truck_no),expression:"cdc_truck_no"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(_vm.cdc_truck_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdc_truck_no=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                Please enter Truck No.\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-12"},[_vm._v("Order Cycle")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdc_cycle_x),expression:"cdc_cycle_x"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(_vm.cdc_cycle_x)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdc_cycle_x=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                  Please enter x.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdc_cycle_y),expression:"cdc_cycle_y"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(_vm.cdc_cycle_y)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdc_cycle_y=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                  Please enter y.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdc_cycle_z),expression:"cdc_cycle_z"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(_vm.cdc_cycle_z)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdc_cycle_z=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                  Please enter z.\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-12"},[_vm._v("Delivery Cycle")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdc_delivery_x),expression:"cdc_delivery_x"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(_vm.cdc_delivery_x)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdc_delivery_x=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                  Please enter x.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdc_delivery_y),expression:"cdc_delivery_y"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(_vm.cdc_delivery_y)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdc_delivery_y=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                  Please enter y.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdc_delivery_z),expression:"cdc_delivery_z"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(_vm.cdc_delivery_z)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdc_delivery_z=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                  Please enter z.\n                ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table customize-table mb-0 v-middle"},[_vm._m(1),_vm._v(" "),(_vm.cycleModalList.length > 0)?_c('tbody',_vm._l((_vm.cycleModalList),function(rsl,j){return _c('tr',{key:'rs' + j},[_c('td',{staticClass:"align-top"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(rsl.cdcl_truck_no),expression:"rsl.cdcl_truck_no"}],staticClass:"form-control",attrs:{"type":"text","required":"","disabled":_vm.checkExpire() < 0},domProps:{"value":(rsl.cdcl_truck_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(rsl, "cdcl_truck_no", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(rsl.cdcl_time_h),expression:"rsl.cdcl_time_h"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"required":"","placeholder":"Choose time house","disabled":_vm.checkExpire() < 0},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(rsl, "cdcl_time_h", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.array_h),function(rth,h){return _c('option',{key:'rth' + h,domProps:{"value":rth}},[_vm._v("\n                          "+_vm._s(rth)+"\n                        ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(rsl.cdcl_time_m),expression:"rsl.cdcl_time_m"}],staticClass:"form-control-line form-select form-select-fix",attrs:{"required":"","placeholder":"Choose time house","disabled":_vm.checkExpire() < 0},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(rsl, "cdcl_time_m", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.array_m),function(rtm,m){return _c('option',{key:'rtm' + m,domProps:{"value":rtm}},[_vm._v("\n                          "+_vm._s(rtm)+"\n                        ")])}),0)])])]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(rsl.cdcl_category))])])}),0):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._m(2),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fix",attrs:{"type":"button","id":"submitbtn"},on:{"click":_vm.checkForm}},[_c('i',{staticClass:"fas fa-save"}),_vm._v(" Save")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"CycleModalLabel"}},[_vm._v("Edit")]),_vm._v(" "),_c('button',{staticClass:"btn-close",attrs:{"type":"button","data-bs-dismiss":"modal","aria-label":"Close"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"table-light"},[_c('tr',[_c('th',{staticStyle:{"width":"25%"}},[_vm._v("Truck")]),_vm._v(" "),_c('th',{staticStyle:{"width":"50%"}},[_vm._v("Ordering Time")]),_vm._v(" "),_c('th',{staticStyle:{"width":"25%"}},[_vm._v("Category")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-secondary btn-fix",attrs:{"type":"button","data-bs-dismiss":"modal","id":"cycleModalclose"}},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Close")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1611:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cycle_add_modal_vue__ = __webpack_require__(1369);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12ac4bee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cycle_add_modal_vue__ = __webpack_require__(1612);
var normalizeComponent = __webpack_require__(509)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cycle_add_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12ac4bee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cycle_add_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1612:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{staticClass:"form-horizontal needs-validation",attrs:{"novalidate":"","id":"formAddCycle"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-xlg-6 col-md-6"},[_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Supplier Code")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.spl_name),expression:"spl_name"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.spl_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.spl_name=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.spl_id),expression:"spl_id"}],staticClass:"form-control",attrs:{"type":"hidden"},domProps:{"value":(_vm.spl_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.spl_id=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Dock")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dk_id),expression:"dk_id"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"required":"","placeholder":"Choose dock..."},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dk_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"selected":"","value":""}},[_vm._v("Choose dock")]),_vm._v(" "),_vm._l((_vm.dockModalList),function(dk,i){return _c('option',{key:'dk' + i,domProps:{"value":dk.dk_id}},[_vm._v("\n                  "+_vm._s(dk.dk_code)+"\n                ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Pattern")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdmp_id),expression:"cdmp_id"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"required":"","placeholder":"Choose pattern..."},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdmp_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"selected":"","value":""}},[_vm._v("Choose pattern")]),_vm._v(" "),_vm._l((_vm.patternModalList),function(cdp,i){return _c('option',{key:'cdp' + i,domProps:{"value":cdp.cdmp_id}},[_vm._v("\n                  "+_vm._s(cdp.cdp_name)+"\n                ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Effective date")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('a-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":'DD/MM/YYYY',"placeholder":"Select Date","required":""},model:{value:(_vm.cdc_date),callback:function ($$v) {_vm.cdc_date=$$v},expression:"cdc_date"}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                Please enter Effective date.\n              ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-xlg-6 col-md-6"},[_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Plant Code")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.spl_plant_code),expression:"spl_plant_code"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.spl_plant_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.spl_plant_code=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Order Process Category")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.opc_id),expression:"opc_id"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.opc_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"selected":"selected","value":"1"}},[_vm._v("0 : Auto order")])])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Truck No.")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdc_truck_no),expression:"cdc_truck_no"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(_vm.cdc_truck_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdc_truck_no=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                Please enter Truck No.\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Order Cycle")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdc_cycle_x),expression:"cdc_cycle_x"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(_vm.cdc_cycle_x)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdc_cycle_x=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                  Please enter x.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdc_cycle_y),expression:"cdc_cycle_y"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(_vm.cdc_cycle_y)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdc_cycle_y=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                  Please enter y.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdc_cycle_z),expression:"cdc_cycle_z"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(_vm.cdc_cycle_z)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdc_cycle_z=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                  Please enter z.\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Delivery Cycle")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdc_delivery_x),expression:"cdc_delivery_x"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(_vm.cdc_delivery_x)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdc_delivery_x=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                  Please enter x.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdc_delivery_y),expression:"cdc_delivery_y"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(_vm.cdc_delivery_y)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdc_delivery_y=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                  Please enter y.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdc_delivery_z),expression:"cdc_delivery_z"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(_vm.cdc_delivery_z)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdc_delivery_z=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                  Please enter z.\n                ")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fix",attrs:{"type":"button","id":"submitbtn"},on:{"click":_vm.checkForm}},[_c('i',{staticClass:"fas fa-save"}),_vm._v(" Save")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"CycleModalLabel"}},[_vm._v("Add")]),_vm._v(" "),_c('button',{staticClass:"btn-close",attrs:{"type":"button","data-bs-dismiss":"modal","aria-label":"Close"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-secondary btn-fix",attrs:{"type":"button","data-bs-dismiss":"modal","id":"cycleModalclose"}},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Close")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1613:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"d-lg-flex"},[_c('div',{staticClass:"col-sm-10"},[_c('h3',{staticClass:"card-title"},[_c('span',{staticClass:"lstick d-inline-block align-middle"}),_vm._v(_vm._s(_vm.$route.meta.title_sub !== '' ? _vm.$route.meta.title_sub : _vm.$route.meta.title)+"\n        ")]),_vm._v(" "),_c('h6',{staticClass:"card-subtitle"})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 text-end"},[_c('button',{staticClass:"btn waves-effect waves-light btn-secondary btn-sm btn-sm-fix",staticStyle:{"width":"48%"},on:{"click":_vm.backTopage}},[_c('i',{staticClass:"fa fa-arrow-left mr-1"}),_vm._v(" Back\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn waves-effect waves-light btn-success btn-sm btn-sm-fix",staticStyle:{"width":"48%"},on:{"click":_vm.addCycle}},[_c('i',{staticClass:"fas fa-plus-circle mr-2"}),_vm._v(" Add")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-2"},[_c('div',{staticClass:"col-sm-6"},[_c('h4',[_vm._v("Supplier: "+_vm._s(this.spl_code + ' | ' + this.spl_name + ' | ' + this.spl_plant_code))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 text-right"})]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-2"},[_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-6 p-r-0 mb-2"},[_c('a-month-picker',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Select Month"},on:{"change":function($event){return _vm.activePage(1)}},model:{value:(_vm.date_select),callback:function ($$v) {_vm.date_select=$$v},expression:"date_select"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-6 p-r-0 mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.is_active),expression:"is_active"}],staticClass:"form-select form-select-sm",attrs:{"name":"active"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.is_active=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.activePage(1)}]}},[_c('option',{attrs:{"value":"99"}},[_vm._v("All")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Wait")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Active")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Expire")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-4 col-xs-12 p-r-0 mb-2 d-grid gap-2"},[_c('button',{staticClass:"btn btn-secondary btn-sm btn-sm-fix",attrs:{"type":"button"},on:{"click":function($event){_vm.active_page = 1
            _vm.search()}}},[_c('i',{staticClass:"fa fa-search mr-1"}),_vm._v(" Search\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive tableFixHead"},[_c('table',{staticClass:"table customize-table mb-0 v-middle"},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('tr',[(_vm.isLoad == true)?_c('td',{staticClass:"text-center",attrs:{"colspan":"11"}},[_c('i',{staticClass:"fas fa-sync-alt fa-spin fa-2x fa-fw"})]):_vm._e()]),_vm._v(" "),_vm._l((_vm.result_data.pagination),function(rs,i){return _c('tr',{key:'rs' + i,class:{ 'bg-light': rs.cdc_is_active === 2 }},[_c('td',{staticClass:"align-top text-center my-border"},[_vm._v(_vm._s(rs.spl_code + ' | ' + rs.spl_plant_code))]),_vm._v(" "),_c('td',{staticClass:"align-top text-center my-border"},[_vm._v(_vm._s(rs.dk_code))]),_vm._v(" "),_c('td',{staticClass:"align-top text-center my-border"},[_vm._v(_vm._s(rs.opc_name))]),_vm._v(" "),_c('td',{staticClass:"align-top text-center my-border"},[_vm._v(_vm._s(_vm.dateFormatDMY(rs.cdc_date)))]),_vm._v(" "),_c('td',{staticClass:"align-top text-center my-border"},[_vm._v(_vm._s(rs.cdc_truck_no))]),_vm._v(" "),_c('td',{staticClass:"align-top text-center my-border"},[_vm._v(_vm._s(rs.cdc_cycle_x + ' - ' + rs.cdc_cycle_y + ' - ' + rs.cdc_cycle_z))]),_vm._v(" "),_c('td',{staticClass:"align-top text-center my-border"},[_vm._v(_vm._s(rs.cdc_delivery_x + ' - ' + rs.cdc_delivery_y + ' - ' + rs.cdc_delivery_z))]),_vm._v(" "),_c('td',{staticClass:"align-top text-center my-border"},[_vm._v(_vm._s(rs.cdp_name + rs.cdc_is_disable))]),_vm._v(" "),_c('td',{staticClass:"text-center align-top my-border"},[_c('span',{staticClass:"badge fw-normal",class:{ 'bg-light-success text-success': rs.cdc_is_active === 1, 'text-secondary': rs.cdc_is_active !== 1 }},[_vm._v("\n                "+_vm._s(rs.cdc_is_active === 1 ? 'Active' : rs.cdc_is_active === 2 ? 'Expire' : 'Wait')+"\n              ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-top my-border"},[_c('span',{staticClass:"badge fw-normal",class:{ 'bg-light-success text-success': rs.cdc_is_disable === 0, 'bg-light-danger text-danger': rs.cdc_is_disable !== 0 }},[_vm._v("\n                "+_vm._s(rs.cdc_is_disable === 0 ? 'Enable' : 'Disable')+"\n              ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-top my-border"},[_c('div',{staticClass:"dropdown dropstart"},[_c('a',{staticClass:"link",attrs:{"href":"#","id":"dropdownMenuButton","data-bs-toggle":"dropdown","aria-expanded":"false"}},[_c('svg',{staticClass:"feather feather-more-horizontal feather-sm",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"1"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"19","cy":"12","r":"1"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"5","cy":"12","r":"1"}})])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu pt-0 pb-0",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('li',[_c('button',{staticClass:"dropdown-item",on:{"click":function($event){return _vm.editCycle(rs)}}},[_vm._v("Edit")])]),_vm._v(" "),_c('li',[_c('button',{staticClass:"dropdown-item",on:{"click":function($event){return _vm.orderStatus(rs)}}},[_vm._v("\n                      Order Status\n                    ")])]),_vm._v(" "),(rs.cdc_is_active !== 1)?_c('li',[_c('button',{staticClass:"dropdown-item",on:{"click":function($event){return _vm.deleteCycle(rs)}}},[_vm._v("Delete")])]):_vm._e()])])])])}),_vm._v(" "),(_vm.result_data.count === 0 && _vm.isLoad == false)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"11"}},[_vm._v("No Data")])]):_vm._e()],2)])]),_vm._v(" "),(parseInt(_vm.result_data.count) > parseInt(_vm.per_page) && _vm.isLoad == false)?_c('div',{staticClass:"text-end mt-3"},[_c('a-pagination',{staticStyle:{"cursor":"pointer"},attrs:{"pageSize":_vm.per_page,"total":_vm.result_data.count,"itemRender":_vm.itemRender},on:{"update:pageSize":function($event){_vm.per_page=$event},"update:page-size":function($event){_vm.per_page=$event},"change":_vm.activePage},model:{value:(_vm.active_page),callback:function ($$v) {_vm.active_page=$$v},expression:"active_page"}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"CycleModal","data-backdrop":"static","data-keyboard":"false","tabindex":"-1","aria-labelledby":"CycleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-fullscreen-md-down modal-lg modal-dialog-centered modal-dialog-scrollable"},[(_vm.modal_type === 1)?_c('CycleEditModal',{attrs:{"modalEditCycle":_vm.modal_data,"loadNewCycle":function () {
            _vm.search = _vm.search
            _vm.activePage(1)
          }}}):_vm._e(),_vm._v(" "),(_vm.modal_type === 0)?_c('CycleAddModal',{attrs:{"modalAddCycle":_vm.modal_data,"loadNewCycle":function () {
            _vm.search = _vm.search
            _vm.activePage(1)
          }}}):_vm._e()],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"table-light"},[_c('tr',[_c('th',{staticClass:"border-bottom border-top text-center my-border"},[_vm._v("Supplier | Plant")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center my-border"},[_vm._v("Dock Code")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center my-border"},[_vm._v("Order Process")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center my-border"},[_vm._v("Effective Date")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center my-border"},[_vm._v("Truck No")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center my-border"},[_vm._v("Order Cycle")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center my-border"},[_vm._v("Delivery Cycle")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center my-border"},[_vm._v("Pattern")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Order Status")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center my-border"},[_vm._v("Actions")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/11.91a6c68ce44fad6778c2.js